export default "__VITE_ASSET__DFCtVbOQ__"